import { Link as LinkMagik, Pagination, createTable } from "@inmagik/magik-ui"
import { FiltersBase, Paratesto } from "../../types"
import { useMemo } from "react"
import { API_URL, PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"
import { useParatestoOrderUpdate, useParatestoPartialUpdate } from "../../hooks/paratesti"
import { fetchApi } from "@inmagik/react-crud"
import { useAuth } from "../../auth"

const Table = createTable<Paratesto>()

export function TableParatesti({
  paratesti,
  setFilters,
  filters,
  count,
  fullCount,
  showEdizione = true,
  actionLink,
  refreshList,
}: {
  paratesti: Paratesto[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
  showEdizione?: boolean
  actionLink?: (v?: Paratesto) => void
  refreshList?: () => void
}) {
  const numPages = useMemo(() => {
    if (!paratesti) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [paratesti, count])

  const { tokens } = useAuth()

  return (
    <Table
      data={paratesti}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Titolo"
        name="titolo"
        width="minmax(00px, 1fr)"
        render={(paratesto) =>
          actionLink ? (
            <LinkMagik className="text-dark" onClick={() => actionLink(paratesto)} style={{ cursor: "pointer" }}>
              {paratesto.titolo ? (
                <span dangerouslySetInnerHTML={{ __html: paratesto.titolo }} />
              ) : (
                'Senza titolo'
              )}
            </LinkMagik>
          ) : (
            <Link to={`/edizioni/paratesti/${paratesto.id}/`}>
              <LinkMagik className="text-dark">
                {paratesto.titolo ? (
                  <span dangerouslySetInnerHTML={{ __html: paratesto.titolo }} />
                ) : (
                  'Senza titolo'
                )}
              </LinkMagik>
            </Link>
          )
        }
      />
      <Table.Column title="Tipologia" name="tipologia" width="200px" render={(paratesto) => paratesto.tipologia} />
      {showEdizione && (
        <Table.Column
          title="Edizione"
          name="titolo_completo_edizione"
          width="300px"
          render={(paratesto) => (
            <div>
              {paratesto.edizione_data.opera_data.titolo} - {paratesto.titolo_completo_edizione}
            </div>
          )}
        />
      )}
      <Table.Column title="Ubicazione" name="ubicazione" width="200px" render={(paratesto) =>
          actionLink ? (
            <LinkMagik className="text-dark" onClick={() => actionLink(paratesto)} style={{ cursor: "pointer" }}>
                {paratesto.ubicazione}
            </LinkMagik>
          ) : (
            <Link to={`/edizioni/paratesti/${paratesto.id}/`}>
              <LinkMagik className="text-dark">
               {paratesto.ubicazione}
              </LinkMagik>
            </Link>
          )
        }
      />
      {!showEdizione && (
        <Table.Column
          title="Ordine"
          name="ordine"
          sortable
          width="100px"
          render={(paratesto) => (
            <div className="d-flex align-items-center">
              {paratesto.ordine}

              <div className="mt-1 ms-2 d-flex">
                <button
                  disabled={paratesto.ordine === 0}
                  className="btn btn-sm btn-outline-secondary me-1"
                  onClick={async () => {
                    await fetchApi(`${API_URL}/admin/paratesti/change-order/?id=${paratesto.id}&direction=up`, {
                      method: "get",
                      headers: {
                        Authorization: `Bearer ${tokens?.access}`,
                        "Content-Type": "application/json",
                      },
                    }).then(() => {
                      if (refreshList) {
                        refreshList()
                      }
                    })
                    
                  }}
                  // disabled={paratesto.ordine <= 1}
                >
                  ↑
                </button>
                <button
                  disabled={paratesto.ordine >= count - 1}
                  className="btn btn-sm btn-outline-secondary"
                  // disabled={paratesto.ordine >= count}
                  onClick={async () => {
                    await fetchApi(`${API_URL}/admin/paratesti/change-order/?id=${paratesto.id}&direction=down`, {
                      method: "get",
                      headers: {
                        Authorization: `Bearer ${tokens?.access}`,
                        "Content-Type": "application/json",
                      },
                    }).then(() => {
                      if (refreshList) {
                        refreshList()
                      }
                    })
                    
                  }}
                >
                  ↓
                </button>
              </div>
            </div>
          )}
        />
      )}

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} paratesti
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
